// extracted by mini-css-extract-plugin
export default {"active-element":"styles_active-element__Qc9Ff","disabled":"styles_disabled__ENGAT"};